import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { RequestBuilder } from '@/core/api/request-builder';
import { StrictHttpResponse } from '@/core/api/strict-http-response';
import { MedicoConflitoInteresseResponse, MedicoNaturezaVinculoResponse } from '@/core/api/sicom-api/registro/medico/conflito-interesse/conflito-interesse.model';
import { Pessoa } from '@/shared/models/pessoa-info.model';
import { SICOM_PATHS } from 'src/sicom-paths';

export function getConflitoInteresse(http: HttpClient, rootUrl: string, params: Pessoa, context?: HttpContext): Observable<StrictHttpResponse<MedicoConflitoInteresseResponse[]>> {
    const rb = new RequestBuilder(rootUrl, getConflitoInteresse.PATH, 'get');
    // Backend espera @ModelAttribute Pessoa com query params planos: id e uf
    rb.query('id', (params as any)?.id, {});
    rb.query('uf', (params as any)?.uf, {});

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>): StrictHttpResponse<MedicoConflitoInteresseResponse[]> => r as unknown as StrictHttpResponse<MedicoConflitoInteresseResponse[]>)
    );
}

export function getConflitoInteresseInativo(http: HttpClient, rootUrl: string, params: Pessoa, context?: HttpContext): Observable<StrictHttpResponse<MedicoConflitoInteresseResponse[]>> {
    const rb = new RequestBuilder(rootUrl, getConflitoInteresseInativo.PATH, 'get');
    // Backend espera @ModelAttribute Pessoa com query params planos: id e uf
    rb.query('id', (params as any)?.id, {});
    rb.query('uf', (params as any)?.uf, {});

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>): StrictHttpResponse<MedicoConflitoInteresseResponse[]> => r as unknown as StrictHttpResponse<MedicoConflitoInteresseResponse[]>)
    );
}

export function getNaturezasVinculo(http: HttpClient, rootUrl: string, context?: HttpContext): Observable<StrictHttpResponse<MedicoNaturezaVinculoResponse[]>> {
    const rb = new RequestBuilder(rootUrl, getNaturezasVinculo.PATH, 'get');

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>): StrictHttpResponse<MedicoNaturezaVinculoResponse[]> => r as unknown as StrictHttpResponse<MedicoNaturezaVinculoResponse[]>)
    );
}

getConflitoInteresse.PATH = SICOM_PATHS.registro.medico.conflitoInteresse.consulta;
getConflitoInteresseInativo.PATH = SICOM_PATHS.registro.medico.conflitoInteresse.inativoConsulta;
getNaturezasVinculo.PATH = SICOM_PATHS.registro.medico.conflitoInteresse.naturezasVinculo;
